import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-custom.js')
      .then((registration) => {
        console.log('SW registered:', registration);

        const showBanner = (worker) => {
          const existing = document.getElementById('sw-update-banner');
          if (existing) return;

          if (sessionStorage.getItem('sw-just-updated')) {
            sessionStorage.removeItem('sw-just-updated');
            return;
          }

          const banner = document.createElement('div');
          banner.id = 'sw-update-banner';
          banner.innerHTML = `
            <div style="
              position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%);
              background: #2563eb; color: white; padding: 14px 28px;
              border-radius: 10px; cursor: pointer; z-index: 9999;
              font-family: sans-serif; font-size: 15px;
              box-shadow: 0 4px 16px rgba(0,0,0,0.3);
              white-space: nowrap;
            ">
              🔄 Aggiornamento disponibile — Tocca per aggiornare
            </div>
          `;
          banner.onclick = () => {
            sessionStorage.setItem('sw-just-updated', 'true');
            worker.postMessage({ type: 'SKIP_WAITING' });
            setTimeout(() => window.location.reload(), 500);
          };
          document.body.appendChild(banner);
        };

        if (registration.waiting) {
          showBanner(registration.waiting);
        }

        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              showBanner(newWorker);
            }
          });
        });

        setInterval(() => {
          registration.update().then(() => {
            console.log('SW update check...');
            if (registration.waiting) {
              showBanner(registration.waiting);
            }
          });
        }, 60 * 1000);

        navigator.serviceWorker.addEventListener('controllerchange', () => {
          window.location.reload();
        });

      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}